export default "__VITE_ASSET__BSZCJO3q__"